module.exports = __webpack_public_path__ + "static/media/live16_02_2023.a27d6f53.jpeg";